import { render, staticRenderFns } from "./clazz.vue?vue&type=template&id=e8817d50&scoped=true"
import script from "./clazz.vue?vue&type=script&lang=js"
export * from "./clazz.vue?vue&type=script&lang=js"
import style0 from "./clazz.vue?vue&type=style&index=0&id=e8817d50&prod&scoped=true&lang=css"
import style1 from "./clazz.vue?vue&type=style&index=1&id=e8817d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8817d50",
  null
  
)

export default component.exports